/**
 * 端末に保存できないことの案内
 * Cookieのブロックなどでログイン状態を保存できない端末に、再読み込み後にもう一度ログインが要る理由を伝えます。
 * 再読み込みの後に戻ってくるログイン・新規登録画面だけに置きます。
 */

import React from 'react';
import { Text, View } from './WebPrimitives';
import { isPersistentStorageAvailable } from '../services/webStorage';

/**
 * 端末に保存できない場合だけ案内を表示する
 * @returns {React.JSX.Element | null} 保存できない場合の案内
 */
const StorageUnavailableNotice = (): React.JSX.Element | null => {
  if (isPersistentStorageAvailable()) {
    return null;
  }

  return (
    <View
      className="rounded-none border-2 border-app-quest-night bg-app-quest-gold px-3 py-2"
      testID="storage-unavailable-notice"
    >
      <Text className="text-sm font-bold leading-6 text-app-quest-night">
        この端末の設定（Cookieのブロックなど）により、ログイン状態や設定を保存できません。ページを再読み込みすると、もう一度ログインが必要です。
      </Text>
    </View>
  );
};

export default StorageUnavailableNotice;
